import Swal from "sweetalert2";

const baseConfig = {
  toast: true,
  timer: 3000,
  position: "bottom-right",
  showConfirmButton: false,
  showCloseButton: true,
};

export const showSuccess = (title = "Success") => {
  Swal.fire({
    ...baseConfig,
    title,
    icon: "success",
  });
};

export const showError = (title = "Something went wrong") => {
  Swal.fire({
    ...baseConfig,
    title,
    icon: "error",
  });
};

export const showWarning = (title = "Warning") => {
  Swal.fire({
    ...baseConfig,
    title,
    icon: "warning",
  });
};